import { IconButton } from '@/components/IconButton'

/**
 * `div.pager` → `pager` (process/08-COMPONENT-CATALOGUE.md). Cursor-only by construction — `Page`
 * carries no total, no offset, no page number, and this renders none: "Previous"/"Next" are the
 * whole control, never a count of pages (§32.8, §24.2 rule 25).
 *
 * **Icon buttons, not text, by explicit request** — a deliberate divergence from
 * Prototype_v2.html's own `.btn.ghost.sm` markup (`design/`'s veto over a prototype value,
 * §24.2c, the same authority the font-family/padding corrections already used this pass), not a
 * bug fix: full-size ghost buttons with "Previous"/"Next" labels repeated at the foot of every
 * table read as oversized and out of place next to the compact row content above them — the
 * modern baseline for cursor pagination (Gmail, Google Drive, Material, Linear) is a borderless
 * chevron `IconButton`, which this app already has one convention for (the `Refresh` control
 * every panel toolbar uses) — reused here rather than inventing a second icon-button style.
 * `label` keeps the accessible name exactly `"Previous"`/`"Next"` — unchanged from the old
 * visible text — so it doesn't disturb the ~26 existing `getByRole('button', { name: 'Next' })`-
 * shaped test assertions across the app.
 */
export function Pager({ hasPrev, hasNext, onPrev, onNext, loading }: { hasPrev: boolean; hasNext: boolean; onPrev: () => void; onNext: () => void; loading?: boolean }) {
  return (
    <div data-cmp="pager" className="flex gap-2">
      <IconButton data-act={undefined} icon="i-chevL" label="Previous" disabled={!hasPrev || loading} onClick={onPrev} />
      <IconButton data-act={undefined} icon="i-chevR" label="Next" disabled={!hasNext || loading} onClick={onNext} />
    </div>
  )
}
